import React, { Component } from "react";
import { Link } from "react-router-dom";

class TopBar extends Component {
  render() {
    return (
      <div id="top-bar">
        <div id="top-bar-inner" className="container">
          <div className="top-bar-inner-wrap">
            <div className="top-bar-content">
              <div className="inner">
                <span className="address content">
                  Ulica kneza Mislava 13, Zagreb
                </span>
                <span className="phone content">+385 91 649 0066</span>
                <span className="time content">Pon-Pet: 9am - 6pm</span>
              </div>
            </div>
            <div className="top-bar-socials">
              <div className="inner">
                <span className="text">Follow us:</span>
                <span className="icons">
                  <a href="https://www.facebook.com/cityxapps">
                    <i className="fa fa-facebook" />
                  </a>
                  <a to="https://www.instagram.com/cityx_apps/">
                    <i className="fa fa-instagram" />
                  </a>
                  <a to="https://www.linkedin.com/company/cityx-apps/">
                    <i className="fa fa-linkedin" />
                  </a>
                  <a to="#">
                    <i className="fa fa-web" />
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TopBar;
